import React, { useState, useEffect, useRef } from "react";
import { QrReader } from "react-qr-reader";
import { useNavigate } from "react-router-dom";
import { auth } from "../config/config-firebase";
import { onAuthStateChanged } from "firebase/auth";
import { jwtDecode } from "jwt-decode";
import API_BASE from "../config/api";
import BottomTabBar from "../components/BottomTabBar";
import AppButton from "../components/AppButton";

const Scanner = () => {
  const [customerMobile, setCustomerMobile] = useState("");
  const [facingMode, setFacingMode] = useState("environment");
  const [statusMessage, setStatusMessage] = useState("");
  const [statusColor, setStatusColor] = useState("");
  const [mobile, setMobile] = useState("");

  const mobileRef = useRef("");
  const navigate = useNavigate();

  useEffect(() => {
    mobileRef.current = mobile;
  }, [mobile]);

  useEffect(() => {
    const openScannerHandler = () => {};
    window.addEventListener("openScanner", openScannerHandler);
    return () => window.removeEventListener("openScanner", openScannerHandler);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      const customerId = localStorage.getItem("customer_id");
      const localPhone = localStorage.getItem("phone");

      if (currentUser) {
        try {
          const idToken = await currentUser.getIdToken(true);
          const jwtTemp = jwtDecode(idToken);
          const userId = jwtTemp.user_id.toString();

          const response = await fetch(`${API_BASE}/getCustomerId`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ userId }),
          });

          const data = await response.json();
          if (response.ok && data.success) {
            setCustomerMobile(data.data.mobile);
            setMobile(data.data.mobile);
            mobileRef.current = data.data.mobile;
          }
        } catch (error) {
          console.error("Error fetching user:", error);
        }
      } else if (customerId && localPhone) {
        setCustomerMobile(localPhone);
        setMobile(localPhone);
        mobileRef.current = localPhone;
      } else {
        navigate("/login");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleScan = async (result) => {
    if (!result?.text) return;

    const scannedText = result.text.trim();
    const loginMobile = mobileRef.current;

    if (!loginMobile) {
      setStatusMessage("Please wait, loading your mobile number...");
      setStatusColor("orange");
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/verifyQr`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          qrPhoneno: scannedText,
          loginPhoneno: loginMobile,
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        if (data.loginStatus && scannedText === loginMobile) {
          setStatusMessage("Verified successfully! Welcome back!");
          setStatusColor("green");
          setTimeout(() => navigate("/home"), 2000);
        } else {
          setStatusMessage("QR does not match your registered number.");
          setStatusColor("red");
        }
      } else {
        setStatusMessage("Verification failed. Please try again.");
        setStatusColor("red");
      }
    } catch (err) {
      console.error("Error calling verifyQr:", err);
      setStatusMessage("Server error during verification.");
      setStatusColor("red");
    }
  };

  const handleError = (err) => {
    if (err?.message && !err.message.includes("NotFoundException")) {
      console.warn("QR Reader Warning:", err.message);
    }
  };

  const statusBg =
    statusColor === "green"
      ? "bg-green-50 border-green-200 text-green-700"
      : statusColor === "orange"
        ? "bg-amber-50 border-amber-200 text-amber-700"
        : "bg-red-50 border-red-200 text-red-700";

  return (
    <div className="min-h-[100dvh] bg-gray-50 w-full flex flex-col pb-24 sm:pb-28">
      <div className="w-full max-w-lg mx-auto flex-1 px-4 sm:px-5 pt-8 sm:pt-10">
        <AppButton
          variant="ghost"
          fullWidth={false}
          onClick={() => navigate("/user-settings")}
          className="mb-4"
        >
          ← Back
        </AppButton>

        <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-1">
          Scanner
        </h1>
        <p className="text-sm text-gray-500 mb-6">
          Scan a barcode or QR code to verify your device
        </p>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 sm:p-6 text-center">
          <QrReader
            constraints={{
              facingMode,
              width: { ideal: 1280 },
              height: { ideal: 720 },
            }}
            onResult={(result, error) => {
              if (result?.text) handleScan(result);
              if (error) handleError(error);
            }}
            videoStyle={{
              width: "100%",
              borderRadius: "12px",
              backgroundColor: "#000",
            }}
          />

          {statusMessage && (
            <div
              className={`mt-5 px-4 py-3 rounded-xl border text-sm font-medium ${statusBg}`}
            >
              {statusMessage}
            </div>
          )}

          {customerMobile && (
            <p className="mt-4 text-xs text-gray-400">
              Registered: {customerMobile}
            </p>
          )}
        </div>
      </div>

      <BottomTabBar />
    </div>
  );
};

export default Scanner;
